<nz-tabset>
  <nz-tab nzTitle="Review & Accept">
    <nz-card>
      <div class="stepper">
        <nz-steps [nzCurrent]="currentStep">
          <nz-step nzTitle="Review"></nz-step>
          <nz-step nzTitle="Add Datasets & Accept"></nz-step>
        </nz-steps>
      </div>
      <app-accept-invitation
        (isFormValid)="isFormValid($event)"
        (updateOwnerOrgType)="setOwnerOrgType($event)"
        *ngIf="currentStep === 0"
      ></app-accept-invitation>
      <app-collaboration-dataset *ngIf="currentStep === 1"></app-collaboration-dataset>

      <div class="action-buttons">
        <div class="left-section">
          <button nz-button nzType="default" (click)="prevStep()" *ngIf="currentStep === 1">Back</button>
        </div>
        <div class="right-section">
          <button nz-button nzType="default" (click)="redirectToList()">Cancel</button>
          <button
            nz-button
            nzType="primary"
            [nzLoading]="isLoading"
            (click)="currentStep === 0 ? next() : acceptInvitation()"
            [disabled]="!isAccepted"
          >
            {{ currentStep === 0 ? 'Next' : 'Accept' }}
          </button>
        </div>
      </div>
    </nz-card>
  </nz-tab>
</nz-tabset>
